// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { any } from "@altostra/type-validations/lib/primitives";

export const isCompanySettingsDataPointUsageResult = objectOf({
  results: any,
});
